import { apiClient } from "../api"

export const getRealTimePositions = () => {
  const ac = apiClient()
  const promise = ac.get('/realtimeposition/')
    .then(res => res.data)
  return promise
}

export const getMobileLocations = (fleetid: number) => {
  const ac = apiClient()
  const promise = ac.get(`/mobilelocation/?fleetid=${fleetid}`)
    .then(res => res.data)
  return promise
}
